import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { cls_item_detail_link, cls_item_detail_link_box, cls_item_link_text, } from "../events/view.css";
import { cls_colorCyan70, cls_gap_half_rem, cls_p5r, cls_wrap } from "style/index.css";
import { getCompetitionNamingResults } from "../entity";
import { cls_align_items_center, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
import { Link } from "framework/link/link";
import { UrlPathOfPublicSection } from "common/paths";
import { cls_arrow_right_box } from "framework/link/link.css";
var Content = function (props) {
    var entity = props.eventState.entity;
    return React.createElement(HBox, { className: cls_wrap }, entity.competitions.filter(function (c) { return c.completedAt != null; }).map(function (c) {
        return React.createElement(HBox, { key: c.competitionId, className: [cls_item_detail_link_box, cls_p5r, cls_colorCyan70] },
            React.createElement(HBox, { className: cls_item_detail_link },
                React.createElement(Link, { url: "".concat(UrlPathOfPublicSection, "/vysledky_soutezi/event/").concat(entity.eventId, "/competition/").concat(c.competitionId) },
                    React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_center] },
                        React.createElement(HBox, { className: cls_item_link_text }, getCompetitionNamingResults(c)),
                        React.createElement(HBox, { className: cls_arrow_right_box })))));
    }));
};
var View = function (props) {
    var showContent = props.eventState.entity != null && !props.eventState.loadFailure;
    return React.createElement(VBox, null,
        showContent && React.createElement(Content, { eventState: props.eventState }),
        props.eventState.loadingTooLong && React.createElement(HBox, { className: [cls_justify_content_center] },
            React.createElement(LoadingSpinner, null)),
        props.eventState.loadFailure && React.createElement(LoadingError, null));
};
export { View as CopmetitionResultEventCompetitions, };
